import { LayoutHOC } from 'base/ui/layout/layout';
import { createHistoryRecieve } from './historyReceive';

export const createHistoryReceivePage = (layoutHOC: LayoutHOC) => {
  return layoutHOC(createHistoryRecieve());
};
